import { useContext } from 'react';

import EnvCropsProductsContext from './EnvCropsProductsContext';

const useEnvCropsProducts = () => {
  return useContext(EnvCropsProductsContext);
};

export default useEnvCropsProducts;
